export default "__VITE_ASSET__C8J5yQUl__"